


const initScrollContainer = () => { 
};

document.addEventListener("DOMContentLoaded", function () {
  initScrollContainer();
});